/*
  Fabric Guide Detail — carousel arrows + scroll-reveal animation.
  No dependencies, no libraries. Everything degrades gracefully:
  - Carousel works via native swipe/scroll even if this script fails to load.
  - Reveal animation just leaves blocks visible if IntersectionObserver
    isn't supported (very old browsers) or if the user has motion reduced.
*/
document.addEventListener('DOMContentLoaded', function () {

  /* ---- Carousel arrows ---- */
  var wraps = document.querySelectorAll('.fabguide-family__carousel-wrap');

  wraps.forEach(function (wrap) {
    var track = wrap.querySelector('.fabguide-carousel__track');
    var prevBtn = wrap.querySelector('[data-fabguide-prev]');
    var nextBtn = wrap.querySelector('[data-fabguide-next]');

    if (!track || !prevBtn || !nextBtn) return;

    function scrollDistance() {
      var slide = track.querySelector('.fabguide-carousel__slide');
      var slideWidth = slide ? slide.getBoundingClientRect().width + 16 : 200;
      return slideWidth * 2;
    }

    prevBtn.addEventListener('click', function () {
      track.scrollBy({ left: -scrollDistance(), behavior: 'smooth' });
    });

    nextBtn.addEventListener('click', function () {
      track.scrollBy({ left: scrollDistance(), behavior: 'smooth' });
    });
  });

  /* ---- Scroll-reveal animation ---- */
  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var families = document.querySelectorAll('.fabguide-family');

  if (prefersReducedMotion || !('IntersectionObserver' in window)) {
    families.forEach(function (el) { el.classList.add('is-visible'); });
    return;
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });

  families.forEach(function (el) { observer.observe(el); });
});